import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MyOrders = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const token = localStorage.getItem("token");

                const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/OrdersAPI/`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });

                const data = await res.json();

                if (data.status) {
                    setOrders(data.orders);
                } else {
                    console.error("Failed to fetch orders");
                }

            } catch (err) {
                console.error("Orders Fetch Error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, []);

    if (loading) {
        return <p className="text-center py-80">Loading orders...</p>;
    }

    return (
        <section className="checkout py-80">
            <div className="container container-lg">
                <div className="row">

                    <div className="col-xl-9 col-lg-8">
                        <div className="pe-xl-5">

                            <h4 className="mb-32">My Orders</h4>

                            {orders.length === 0 ? (
                                <p>No orders found ❌</p>
                            ) : (
                                orders.map((order) => (
                                    <div
                                        key={order.order_id}
                                        className="border border-gray-100 rounded-8 px-24 py-24 mb-32"
                                    >

                                        {/* Order Header */}
                                        <div className="flex-between mb-16">
                                            <div>
                                                <h6>Order #{order.order_id}</h6>
                                                <p className="text-gray-500">
                                                    {new Date(order.date).toLocaleString()}
                                                </p>
                                            </div>

                                            <div>
                                                <span className="badge bg-warning text-dark">
                                                    {order.status}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Items */}
                                        {order.items.map((item) => (
                                            <div
                                                key={item.product_id}
                                                className="flex-between align-items-center border-top pt-16 mt-16"
                                            >
                                                <div className="flex-align gap-16">
                                                    <img
                                                        src={item.image?.src}
                                                        alt={item.name}
                                                        width="60"
                                                        height="60"
                                                        style={{ objectFit: "cover", borderRadius: "8px" }}
                                                    />

                                                    <div>
                                                        <p className="fw-semibold">{item.name}</p>
                                                        <p className="text-gray-500">
                                                            Qty: {item.quantity}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div>
                                                    <p className="fw-bold">₹{item.total}</p>
                                                     <button
                                                        className="btn btn-main mt-12"
                                                        onClick={() =>
                                                            navigate("/review-product", {
                                                                state: {
                                                                    product: item
                                                                }
                                                            })
                                                        }
                                                    >
                                                        Rate & Review
                                                    </button>
                                                </div>
                                            </div>
                                        ))}

                                        {/* Footer */}
                                        <div className="flex-between mt-24 pt-16 border-top">
                                            <div>
                                                <p className="text-gray-500">
                                                    Payment: {order.payment_method}
                                                </p>
                                            </div>

                                            <div>
                                                <h6>Total: ₹{order.total}</h6>
                                            </div>
                                        </div>

                                    </div>
                                ))
                            )}

                        </div>
                    </div>

                    {/* Sidebar (Optional same style as checkout) */}
                    <div className="col-xl-3 col-lg-4">
                        <div className="checkout-sidebar">
                            <div className="bg-color-three rounded-8 p-24 text-center">
                                <span className="text-gray-900 text-xl fw-semibold">
                                    Orders Summary
                                </span>
                            </div>

                            <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
                                <div className="flex-between">
                                    <span>Total Orders</span>
                                    <span>{orders.length}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default MyOrders;